import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-role',
  imports: [CommonModule],
  templateUrl: './role.html',
  styleUrl: './role.scss'
})
export class Role implements OnInit {
  roles: any[] = [];
  selectedRole: any = null;
  isRoleAdmin: boolean = false;

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
    this.loadRoles();
    this.isRoleAdmin = localStorage.getItem('super_admin') === '/admin';
  }

  loadRoles() {
    const user = localStorage.getItem('user');
    if (user) {
      const parsedUser = JSON.parse(user);
      this.roles = parsedUser?.roles || [];
      
      // Check if there's a previously selected role in localStorage
      const storedRole = localStorage.getItem('selectedRole');
      if (storedRole) {
        this.selectedRole = JSON.parse(storedRole);
      } else {
        // Default to first role if no stored selection
        this.selectedRole = this.roles[0] || null;
        // Store the default selection
        if (this.selectedRole) {
          localStorage.setItem('selectedRole', JSON.stringify(this.selectedRole));
        }
      }
    }
  }

  selectRole(role: any) {
    this.selectedRole = role;
    // Let the role-change redirect leave a dirty form (same exemption as logout).
    this.authService.beginRoleChange();
    localStorage.setItem('selectedRole', JSON.stringify(role));
    window.dispatchEvent(new CustomEvent('roleChanged', { detail: role }));
  }

}
